module.exports = __webpack_public_path__ + "img/alert.9db359ce.svg";